
import {Component, Prop, Vue} from "vue-property-decorator";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({})
  export default class NoAccessMessage extends Vue {
    @Prop() freeSaldoFlag: boolean;

    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }

  }
